import clsx from 'clsx'
import { useMemo } from 'preact/hooks'
import { useSwatches } from '@/components/hooks/useSwatches'
import { normalisedArray } from 'libs/searchspring/helpers/normalisers'

export function ResultsSwatches ({ swatches }) {
  if (swatches.length > 1) {
    return <p className='paragraph-xs text-neutral-primary'>More colours available</p>
  }
}

export function QuickAddSwatches({ result, swatches, onSelectSwatch }) {
  if (!swatches || swatches.length === 0) return null
  const currentSwatch = swatches.filter((swatch) => swatch.handle === result.handle)
  return (
    <>
      <p className='paragraph-s'><span className='font-medium'>Colour</span>: <span className='capitalize'>{currentSwatch[0].colourName.toLowerCase()}</span></p>
      <div className="flex flex-wrap gap-x-0.375 gap-y-0.25 justify-between">
        <div className="flex flex-wrap gap-x-0.375 gap-y-0.25">
          {swatches.slice(0, 7).map((swatch) => {
            return (
              <Swatch
                key={swatch.handle}
                swatch={swatch}
                onSelectSwatch={onSelectSwatch}
                isCurrentSwatch={swatch.handle === result.handle}
              />
            )
          })}
        </div>
        {swatches.length > 7 && <a href={result.url} className="flex items-center text-xs text-brand-black underline underline-offset-4">+{swatches.length - 7} More Colours</a>}
      </div>
    </>
  )
}

function Swatch({ swatch, onSelectSwatch, isCurrentSwatch }) {
  function handleClick() {
    onSelectSwatch(swatch.handle)
  }

  const tags = useMemo(() => normalisedArray(swatch?.tags) ?? [], [swatch?.tags])

  const colour = useMemo(() => {
    const tag = tags.find((tag) => tag.includes('Hex'))
    if (!tag) return 'var(--colour-accent)'

    return tag.split('-').pop()
  }, [tags])

  const isLightColour = useMemo(() => {
    const hexColour = colour.toLowerCase()
    return !hexColour || hexColour === '#ffffff' || hexColour === '#fff' || hexColour === 'white'
  }, [colour])

  const criteria = useMemo(() => ({ tags }), [tags])

  const altSwatch = useSwatches(criteria)

  return (
    <button
      className={clsx(
        'overflow-hidden flex size-1.75 shrink-0 bg-[--bg-colour] transition-all',
        isCurrentSwatch ? 'border border-black' : ''
      )}
      style={{
        '--bg-colour': altSwatch.length > 0 && altSwatch[0].background_colour ? altSwatch[0].background_colour : colour,
        ...(isLightColour && { boxShadow: 'inset 0px 0px 0px 1px var(--darkGrey)' })
      }}
      onClick={handleClick}
      aria-label="View product"
      data-dl-track="toggle_variant"
      data-dl-product-id={swatch.productLegacyResourceId}
      data-dl-variant-id={swatch.productLegacyResourceId}
      data-dl-attribute="item_colour"
      data-dl-value={swatch.colourName}
    >
      {altSwatch.length > 0 && altSwatch[0].image && (
        <img src={altSwatch[0].image} alt="Product swatch" className="size-full object-cover" />
      )}
    </button>
  )
}
